import { jsx as e } from "react/jsx-runtime";
import { useTranslation as t } from "react-i18next";
var n = {
	filtersContainer: "_filtersContainer_1y4bx_1",
	oc: "_oc_1y4bx_35",
	default: "_default_1y4bx_39",
	filter: "_filter_1y4bx_1",
	active: "_active_1y4bx_95"
}, r = ({ dataTestId: r, handleMarketChange: i, isOC: a, marketGroupNames: o, selectedMarketGroup: s }) => {
	let { t: c } = t("label"), l = a ? "oc" : "default";
	return /* @__PURE__ */ e("div", {
		className: [n.filtersContainer, n[l]].join(" "),
		"data-testid": r || "filters",
		children: o.map((t) => {
			let r = s === t;
			return /* @__PURE__ */ e("button", {
				"aria-pressed": r,
				className: [
					n.filter,
					n[l],
					r ? n.active : ""
				].join(" "),
				"data-testid": "filter-button",
				onClick: () => {
					i(t);
				},
				children: c(t)
			}, t);
		})
	});
}, i = r;
//#endregion
export { r as n, i as t };
